import { API_BASE, AUTH_TOKEN } from '../config';

// Thin fetch wrapper against the shared HypeTunes API.
async function get(path) {
  const headers = {};
  if (AUTH_TOKEN) headers.Authorization = `Bearer ${AUTH_TOKEN}`;
  const res = await fetch(`${API_BASE}${path}`, { headers });
  if (!res.ok) throw new Error(`API ${path} -> ${res.status}`);
  return res.json();
}

// POST that returns { res, data } so callers can branch on status (the Anam
// cameo path treats 429/503 as "back off", not an error) — mirrors useVideoHost.
async function post(path, body) {
  const headers = { 'Content-Type': 'application/json' };
  if (AUTH_TOKEN) headers.Authorization = `Bearer ${AUTH_TOKEN}`;
  const res = await fetch(`${API_BASE}${path}`, { method: 'POST', headers, body: JSON.stringify(body || {}) });
  const data = await res.json().catch(() => ({}));
  return { res, data };
}

export const api = {
  // District station now-playing [reuse existing radio endpoint]
  stationNow: (slug) => get(`/api/radio/stations/${encodeURIComponent(slug)}/now`),
  stations: () => get('/api/radio/stations'),

  // World modulation track (compact per-track analysis) — added to the API
  // as a NEW read-only endpoint (does not change any existing behavior).
  worldModulation: (trackId) => get(`/api/world/modulation/${trackId}`),

  // World bootstrap: districts, residents, venues (NEW additive endpoint).
  worldState: () => get('/api/world/state'),

  // Featured tracks — the same list /listen + the landing page use. Public,
  // returns signed artwork_url + audio_url + title + avatar_name per track.
  featuredTracks: () => get('/api/tracks/featured'),

  // Music videos (the /listen discover reel). gcs_url + aspect_ratio + title +
  // avatar_name; mostly 16:9. Used for moving-clip billboards.
  musicVideos: (limit = 24) => get(`/api/music-videos/discover?limit=${limit}`),

  // HypeClips — the /listen "HypeClips" row. Vertical 9:16 narrative clips
  // (avatar_videos, video_type='hypeclip', featured). Signed gcs_url + title +
  // avatar_name + track_id. Played on the tall city signs.
  hypeClips: (limit = 24) => get(`/api/videos/hypeclips/featured?limit=${limit}`),

  // Featured artists (is_featured_artist = 1, active) — the NPC roster source.
  // avatar_id + name + handle + main_genre + profile_image_url. The World joins
  // this against models/avatars/roster.json to place engageable resident NPCs.
  featuredArtists: () => get('/api/featured-artists/showcase'),

  // Who this viewer follows → { following: [{ avatar_id, … }] }. The map marks
  // the ones present as residents (followed ∩ roster) with a headshot pin.
  following: () => get('/api/feed/following/list'),

  // This viewer's OWN avatars → { avatars: [{ avatar_id, … }] } (findByUserId).
  // The map marks these too — "mine," distinct from "following."
  myAvatars: () => get('/api/avatars'),

  // ── Radio VIDEO HOST cameo (the DJ on the big billboards) — same endpoints
  // the website's useVideoHost drives. All authed; the cameo is a paid-plan +
  // server-appearance-budget gate (no credit charge). stationId is numeric
  // (read station.station_id off the now-playing payload).
  anamRadioStatus: (stationId) => get(`/api/anam/radio/${stationId}/status`),
  anamRadioSessionToken: (stationId) => post(`/api/anam/radio/${stationId}/session-token`, {}),
  anamSessionTurn: (sessionId, body) => post(`/api/anam/session/${sessionId}/turn`, body),
  anamSessionReport: (sessionId, body) => post(`/api/anam/session/${sessionId}/report`, body)
};